import { useId } from 'react'
import { useTranslation } from 'react-i18next'
import { cn } from '~/lib/utils'

const RATINGS = [1, 2, 3, 4, 5] as const

/**
 * Une note de 1 à 5 (#320), en boutons radio natifs : le clavier et les lecteurs
 * d'écran les connaissent, les flèches passent d'une note à l'autre.
 */
function RatingField({ legend, value, onChange }: { legend: string, value: number | null, onChange: (value: number) => void }) {
  const { t } = useTranslation()
  const name = useId()

  return (
    <fieldset className="flex flex-col gap-2">
      <legend className="mb-2 text-sm font-medium">{legend}</legend>
      <div className="flex flex-wrap items-center gap-2">
        <span className="text-xs text-muted-foreground" aria-hidden>{t('survey.scale.low')}</span>
        {RATINGS.map(rating => (
          <label
            key={rating}
            className={cn(
              'flex size-10 cursor-pointer items-center justify-center rounded-md border border-input text-sm has-[:focus-visible]:ring-2 has-[:focus-visible]:ring-ring',
              value === rating && 'border-primary bg-primary text-primary-foreground',
            )}
          >
            <input type="radio" name={name} value={rating} checked={value === rating} onChange={() => onChange(rating)} className="sr-only" aria-label={t('survey.scale.option', { rating })} />
            <span aria-hidden>{rating}</span>
          </label>
        ))}
        <span className="text-xs text-muted-foreground" aria-hidden>{t('survey.scale.high')}</span>
      </div>
    </fieldset>
  )
}

export default RatingField
